import React from 'react';
import { SVGProps } from './types';

const PlusIcon = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        d="M8 2.667v10.666M2.667 8h10.666"
      />
    </svg>
  );
};

export { PlusIcon };
